import React, { useMemo } from "react";
import DataTable from "react-data-table-component";
import Loading from "../../components/loading";
import Pagination from "../../components/Pagination";
import moment from "moment";
import { useNavigate } from "react-router";

const ItemList = ({
  totalPages,
  totalItems,
  page,
  setPage,
  limit,
  setLimit,
  products = [],
  isLoading,
  selectedProductId,
  onSelectProduct,
  openItemModal,
  deleteItem,
}) => {
  /* ===== SAME DATA PROCESSING ===== */
  const navigate = useNavigate();
  const processedProducts = useMemo(() => {
    return (products || []).map((product) => {
      const validBatches = product?.batches || [];

      const latestBatch = validBatches
        .filter((b) => b.purchasePrice > 0)
        .sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate))[0];

      const totalRemainingQty = validBatches.reduce(
        (sum, b) => sum + (b.remainingQty || 0),
        0,
      );

      return {
        ...product,
        latestPurchasePrice: latestBatch ? latestBatch.purchasePrice : 0,
        totalRemainingQty,
        minStockAlert: product?.minStockAlert || 0,
        isBelowMinStock: totalRemainingQty <= (product.minStockAlert || 0),
        expiryDate: latestBatch?.expiryDate || null,
      };
    });
  }, [products]);

  const selectedBusiness = JSON.parse(localStorage.getItem("selectedBusiness"));
  const dbName = selectedBusiness?.tenantDB;
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#0b2b6d",
        minHeight: "52px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#0b2b6d",
        color: "#ffffff",
        // fontWeight: "600",
        // fontSize: "14px",
        textTransform: "uppercase",
      },
    },
  };

  /* ===== DATA TABLE COLUMNS ===== */
  const columns = [
    {
      name: "S.No",
      width: "70px",
      cell: (_, index) => (page - 1) * limit + index + 1,
    },
    {
      name: "Image",
      width: "90px",
      // center: true,
      cell: (row) => (
        <div className="py-2">
          {row?.image ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${dbName}/product_images/${row.image}`}
              alt={"image"}
              className="rounded border"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              className="bg-light border rounded d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px" }}
            >
              <i className="bi bi-image text-muted"></i>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "150px",
      style: { whiteSpace: "nowrap" },
    },
    {
      name: "Item Code",
      selector: (row) => row.productCode || "—",
      width: "150px",
      style: { whiteSpace: "nowrap" },
    },
    {
      name: "HSN",
      selector: (row) => row.hsnCode || "—",
    },
    // {
    //   name: "Purchase Price (₹)",
    //   cell: (row) => `${Number(row.latestPurchasePrice).toFixed(2)}`,
    //   width: "160px",
    //   style: { whiteSpace: "nowrap" },
    // },

    {
      name: "Sale Price (₹)",
      cell: (row) => ` ${Number(row.salePrice || 0).toFixed(2)}`,
      width: "150px",
      style: { whiteSpace: "nowrap" },
    },
    {
      name: "In Stock",
      cell: (row) => (
        <span className={row.totalRemainingQty < 0 ? "text-danger" : ""}>
          {row.totalRemainingQty} {row?.unit?.name || ""}
        </span>
      ),
    },
    // {
    //   name: "Discount",
    //   width: "110px",
    //   cell: (row) => {
    //     if (row.discount > 0) {
    //       return (
    //         <span className="text-nowrap text-danger px-3 py-2 rounded-pill">
    //           {row.discount}% OFF
    //         </span>
    //       );
    //     }
    //     return <span className="text-muted">—</span>;
    //   },
    // },
    {
      name: "Location",
      selector: (row) => row.location || "-",
      width: "150px",
      style: { whiteSpace: "nowrap" },
    },
    {
      name: "GST Rate (%)",
      selector: (row) => row.gstRate || "-",
      width: "150px",
      style: { whiteSpace: "nowrap" },
    },
    {
      name: "Min Stock Alert",
      width: "150px",
      style: { whiteSpace: "nowrap" },
      cell: (row) => (
        <span className={row.isBelowMinStock ? "text-danger" : ""}>
          {row.minStockAlert} {row?.unit?.name || ""}
        </span>
      ),
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD MMM, YYYY"),
      width: "120px",
    },
    // {
    //   name: "Expiry Date",
    //   selector: (row) =>
    //     row.expiryDate
    //       ? moment(row.expiryDate).format("DD MMM, YYYY")
    //       : "—",
    //   width: "140px",
    // },
    {
      name: "Action",
      // center: true,
      width: "120px",
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <button
            className="btn btn-light btn-sm shadow-sm me-1 text-primary border"
            title="Edit"
            onClick={(e) => {
              e.stopPropagation();
              openItemModal(true, row);
            }}
          >
            <i className="bi bi-pencil"></i>
          </button>

          <button
            className="btn btn-light btn-sm shadow-sm text-danger border"
            title="Delete"
            onClick={(e) => {
              e.stopPropagation();
              deleteItem(row._id);
            }}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="card product-list-card">
        <div className="card-body p-0">
          <DataTable
            columns={columns}
            data={processedProducts}
            progressPending={isLoading}
            customStyles={customStyles}
            progressComponent={<Loading />}
            noDataComponent={
              <div className="text-center p-5 text-muted">
                <i className="bi bi-inbox display-1"></i>
                <p className="mt-3">No items found.</p>
              </div>
            }
            highlightOnHover
            striped
            // fixedHeader
            // fixedHeaderScrollHeight="550px"
            onRowClicked={(row) => navigate(`/items/details/${row._id}`)}

            // conditionalRowStyles={[
            //   {
            //     when: (row) => row._id === selectedProductId,
            //     style: {
            //       backgroundColor: "#e7f1ff",
            //     },
            //   },
            // ]}
          />
        </div>
      </div>
      {/* ===== SAME PAGINATION COMPONENT ===== */}
      {totalItems > 0 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          totalItems={totalItems}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(1);
          }}
          loading={isLoading}
        />
      )}
      {/*  <div className="d-flex justify-content-start mt-3 mb-3">
        <button type="button" className="btn btn-primary" onClick={() => {}}>
          Add +
        </button>
      </div>*/}
    </>
  );
};

export default ItemList;
